export default __webpack_public_path__ + "static/media/g1.3e573af9.PNG";